import * as holidayJp from '@holiday-jp/holiday_jp'

/**
 * Returns the Japanese public holiday name for a given local calendar date.
 * @param {number} year
 * @param {number} month 1-12
 * @param {number} day
 * @returns {string}
 */
export function getJapaneseHolidayLabel(year, month, day) {
  const date = new Date(year, month - 1, day)
  const holidays = holidayJp.between(date, date)
  if (!holidays.length) return ''
  return holidays.map((item) => item.name).join('・')
}
